import { RootState } from '../store.types';

export const hasReceivedWaitingUsersSelector = ({ waitingUsers: reducer }: RootState) =>
    reducer.hasReceivedWaitingUsers;

export const hasReceivedAllWaitingUsersSelector = ({ waitingUsers: reducer }: RootState) =>
    reducer.hasReceivedAllWaitingUsers;

export const waitingUsersSelector = ({ waitingUsers: reducer }: RootState) => reducer.waitingUsers;
